export const useCreateClusterValidation = initialForm => {
  const {
    name,
    productType,
    lowerPrepTimeDays,
    lowerPrepTimeHours,
    lowerPrepTimeMins,
    upperPrepTimeDays,
    upperPrepTimeHours,
    upperPrepTimeMins
  } = initialForm;

  const nameMessage = () => {
    if (name === "" || name === null) {
      return "This field is required.";
    }

    return null;
  };

  const productTypeMessage = () => {
    if (productType === "" || productType === null) {
      return "This field is required.";
    }

    return null;
  };

  const lowerPrepTimeDaysMessage = () => {
    if (lowerPrepTimeDays === "" || lowerPrepTimeDays === null) {
      return "This field is required.";
    }

    return null;
  };

  const lowerPrepTimeHoursMessage = () => {
    if (lowerPrepTimeHours === "" || lowerPrepTimeHours === null) {
      return "This field is required.";
    }

    return null;
  };

  const lowerPrepTimeMinsMessage = () => {
    if (lowerPrepTimeMins === "" || lowerPrepTimeMins === null) {
      return "This field is required.";
    }

    return null;
  };

  const upperLimitValidation = () => {
    const totalLowerLimit =
      parseInt(lowerPrepTimeDays, 0) * 1440 +
      parseInt(lowerPrepTimeHours, 0) * 60 +
      parseInt(lowerPrepTimeMins, 0);

    const totalUpperLimit =
      parseInt(upperPrepTimeDays, 0) * 1440 +
      parseInt(upperPrepTimeHours, 0) * 60 +
      parseInt(upperPrepTimeMins, 0);

    if (totalLowerLimit > totalUpperLimit) {
      return "Upper limit total should be higher than the lower limit";
    }

    return null;
  };

  const upperPrepTimeDaysMessage = () => {
    if (upperPrepTimeDays === "" || upperPrepTimeDays === null) {
      return "This field is required.";
    }

    return upperLimitValidation();
  };

  const upperPrepTimeHoursMessage = () => {
    if (upperPrepTimeHours === "" || upperPrepTimeHours === null) {
      return "This field is required.";
    }

    return upperLimitValidation();
  };

  const upperPrepTimeMinsMessage = () => {
    if (upperPrepTimeMins === "" || upperPrepTimeMins === null) {
      return "This field is required.";
    }

    return upperLimitValidation();
  };

  return {
    lowerPrepTimeDays: lowerPrepTimeDaysMessage(),
    lowerPrepTimeHours: lowerPrepTimeHoursMessage(),
    lowerPrepTimeMins: lowerPrepTimeMinsMessage(),
    name: nameMessage(),
    productType: productTypeMessage(),
    upperPrepTimeDays: upperPrepTimeDaysMessage(),
    upperPrepTimeHours: upperPrepTimeHoursMessage(),
    upperPrepTimeMins: upperPrepTimeMinsMessage()
  };
};
